/* eslint-disable @typescript-eslint/no-explicit-any */
import { mauticURL, functionsURL } from "$lib/config/nucamp.client.json";
import type { NucampUser } from "$lib/datamodel";
import { auth } from "../firebase";

export async function formPost(params: any){
  const formData = new URLSearchParams();

  for (const mparam in params) {
    if (mparam) {
      formData.append('mauticform[' + mparam + ']', params[mparam]);
    }
  }

  try {
    await fetch(`${mauticURL}/form/submit?`, {
      method: "POST",
      body: formData
    }).catch(() => {
      // console.log("Error in formPost");
      return Promise.resolve();
    })
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  } catch (error) {
    // console.log("Error in formPost");
  }
}

function subs(content:any, subs:any, escape:any) {
  let subdContent = content;
  Object.keys(subs).forEach(key => {
    const regex = new RegExp(`${escape[0]}${key}${escape[1]}`,"g");
    subdContent = subdContent.replace(regex, subs[key]);
  })
  return subdContent;
}

export function parseEmail(substitutions:any, template:any) {
  const body1 = encodeURIComponent(subs(template.body, substitutions, ['{', '}']));
  const body2 = subs(body1, {crlf: "%0D%0A"}, ['',''])
  return `mailto:${encodeURIComponent(subs(template.mailto, substitutions, ['{', '}']))}
    ?subject=${encodeURIComponent(subs(template.subject, substitutions, ['{', '}']))}
    &${encodeURIComponent("content-type")}=${encodeURIComponent("text/plain")}
    &cc=${encodeURIComponent(subs(template.cc, substitutions, ['{', '}']))}
    &body=${body2}`;
}

export async function sendEmail(message: any) {
  const authToken = await auth?.currentUser?.getIdToken();

  return fetch(`${functionsURL}/app/mautic/sendemail`, {
    method: "POST",
    headers: { 
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${authToken}`,
    },
    body: message
  })
  .then((result) => result.json())
  .catch((error) => {
    return error.json()
  });
}

export async function updateMautic(contact: any) {
  const authToken = await auth?.currentUser?.getIdToken();

  return fetch(`${functionsURL}/app/mautic/updatecontact`, {
    method: "POST", 
    headers: { 
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${authToken}`,
    },
    body: contact
  })
  .then((result) => result.json())
  .catch((error) => {
    return error.json()
  });
}

export function AddEmployeeToBusinessCampaign (user: NucampUser, formID: number){
  let usrphone = "";
  const fformId = formID;

  if (user.phone) usrphone = user.phone.toString(); 

  const formData: any = {
    'your_first_name': user.firstname,
    'your_last_name': user.lastname,
    'your_email': user.email,
    'your_phone': usrphone,
    'your_mobile': usrphone,
    'formId': fformId,
  }
  if (user?.company?.url) formData['companywebsite'] = user.company.url;

  return formPost(formData);
}

export function AddUserToBootcampFollowStream (user: NucampUser, location: string, state: string, nucampFlex: boolean, formID: number){
  let usrphone = "";
  let fformId = formID;
  
  // Overriding the bootcamp nurture stream if it's not Job Hunting or Cybersecurity. Otherwise all nurture go to the "All Bootcamp" nurture campaign
  if (fformId !== 33 && fformId !== 56) fformId = 52;

  if (user.phone) usrphone = user.phone.toString(); 

  const formData:any = {
    'your_first_name': user.firstname,
    'your_last_name': user.lastname,
    'your_email': user.email,
    'your_phone': usrphone,
    'your_mobile': usrphone,
    'formId': fformId,
  }
  if (location) formData["your_preferred_location"] = location;
  if (state) formData["preferred_state"] = state;
  if (nucampFlex) formData["nucamp_flex"] = nucampFlex;
  if (user.communityUrlId) formData["community_urlid"] = user.communityUrlId;

  return formPost(formData);
}

export function AddUserToEloquentJavaScriptOffering (user: NucampUser, location: string, state: string){
  let usrphone = "";

  if (user.phone) usrphone = user.phone.toString(); 
  const formData:any = {
    'your_first_name': user.firstname,
    'your_last_name': user.lastname,
    'your_preferred_location': location,
    'preferred_state': state,
    'your_email': user.email,
    'your_phone': usrphone,
    'your_mobile': usrphone,
    'formId': 54,
  }
  if (user.communityUrlId) formData["community_urlid"] = user.communityUrlId;
  // console.log(formData);
  return formPost(formData);
}

export function CaptureUserData (user: NucampUser, location: string, state: string, nucampFlex: boolean){
  if ((user.firstname == undefined && user.lastname == undefined) || (user.firstname == "undefined" || user.lastname == "undefined")) {
    return Promise.resolve();
  }
  const formID = 12;
  const formData:any  = {
    'first_name': user.firstname,
    'last_name': user.lastname,
    'formId': formID,
  }
  if (user.phone) formData["phone"] = user.phone;
  if (user.phone) formData["mobile"] = user.phone;
  if (location) formData["preferred_location"] = location;
  if (nucampFlex) formData["nucamp_flex"] = nucampFlex;
  if (state) formData["preferred_state"] = state;
  if (user.email) formData["email"] = user.email;
  if (user.communityUrlId) formData["community_urlid"] = user.communityUrlId;

  return formPost(formData);
}

export function eMailNewsletter (email: string, name?: {firstName: string, lastName: string}){ 
  const formID = 20;
  let firstname = '';
  let lastname = '';
  if (name) {
    if (name.firstName) firstname = name.firstName;
    if (name.lastName) lastname = name.lastName;
  }
  const formData = {
    'email': email,
    'firstname': firstname,
    'lastname': lastname,
    'formId': formID,
  }
  return formPost(formData);
}